const getAbbr = (companyID, abbrList) => {
  if (!companyID || !abbrList) return '';

  return abbrList.find((abbr) => abbr.id === Number(companyID)).abbr;
};

export default getAbbr;
